import React from 'react'
import { Oval } from 'react-loader-spinner'

function LoadingSpinner({ secondaryColor = '#BEBECE', color = '#153c4f', height = '100vh' }) {
    return (
        <div className="feed-loader" style={{ height }}>
            <Oval secondaryColor={secondaryColor} color={color} height={80} width={80} />
        </div>
    )
}

export default LoadingSpinner
